module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av696-4316be8bad3ee7285843218bca6fff8a.jpg";